import { render, staticRenderFns } from "./BugReportListView.vue?vue&type=template&id=f367a85a&scoped=true&"
import script from "./BugReportListView.vue?vue&type=script&lang=ts&"
export * from "./BugReportListView.vue?vue&type=script&lang=ts&"
import style0 from "./BugReportListView.vue?vue&type=style&index=0&id=f367a85a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f367a85a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
